import React, { lazy, memo } from 'react';
export function SolutionSection() {
  const steps = [{
    number: '1',
    title: 'Open the guides',
    desc: 'Start with the exact topic you need most — portraits, angles, action, lighting, phone basics, or final results.'
  }, {
    number: '2',
    title: 'Choose the kind of photo you want',
    desc: 'Pick the look, moment, or style you want to create with your dog.'
  }, {
    number: '3',
    title: 'Apply it with your dog',
    desc: 'Use the simple step-by-step guidance to get better photos without guessing every time.'
  }];
  return <section className="bg-warm-light py-16 md:py-24 px-4" data-id="element-345">
      <div className="max-w-3xl mx-auto" data-id="element-346">
        {/* Solution badge */}
        <div className="text-center mb-4" data-id="element-347">
          <span className="inline-block bg-green-100 text-green-800 font-sans font-bold text-sm px-4 py-1.5 rounded-full" data-id="element-348">
            ✅ THE SOLUTION
          </span>
        </div>

        {/* Headline */}
        <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl font-bold text-center text-warm-hero mb-4 leading-tight" data-id="element-349">
          The <span className="italic text-soft-gold" data-id="element-350">Pawfect</span> Shot
          MegaPack
        </h2>

        {/* Subheadline */}
        <p className="font-sans text-lg md:text-xl text-gray-700 text-center mb-10 max-w-2xl mx-auto leading-relaxed" data-id="element-351">
          A complete dog photography system designed for everyday dog owners who
          want beautiful, professional-looking photos using only their phone.
        </p>

        {/* How it works */}
        <h3 className="font-serif text-2xl md:text-3xl font-bold text-center text-warm-hero mb-8" data-id="element-352">
          How it works
        </h3>

        <div className="space-y-6 mb-10" data-id="element-353">
          {steps.map(step => <div key={step.number} className="bg-white p-6 md:p-8 rounded-2xl shadow-sm border border-soft-gold/15 flex items-start gap-5" data-id="element-354">
              <div className="flex-shrink-0 w-12 h-12 rounded-full bg-soft-gold text-white font-sans font-bold text-xl flex items-center justify-center" data-id="element-355">
                {step.number === '1' ? '📂' : step.number === '2' ? '👀' : '📸'}
              </div>
              <div data-id="element-356">
                <h4 className="font-sans font-bold text-lg md:text-xl text-warm-hero mb-1" data-id="element-357">
                  {step.title}
                </h4>
                <p className="font-sans text-gray-600 leading-relaxed" data-id="element-358">
                  {step.desc}
                </p>
              </div>
            </div>)}
        </div>

        {/* Closing */}
        <p className="font-sans text-lg md:text-xl text-center text-gray-800 max-w-2xl mx-auto leading-relaxed" data-id="element-359">
          No overthinking. No technical overload. No more guessing every time
          you open your camera.
          <br data-id="element-360" />
          <br data-id="element-361" />
          <span className="font-semibold text-warm-hero" data-id="element-362">
            Just a simple, structured system that helps you capture photos you
            will actually love.
          </span>
        </p>
      </div>
    </section>;
}